<div *ngIf="message" style="position: relative;">
    <div class="background-hover" [class.overlay-danger]="message.numReports > 0 && !message.deleted && message.inappropriate == null" [style.opacity]="message.deleted || message.inappropriate ? 0.5 : 1.0">
        <div>
            <div class="float-start">
                <img src="{{ message.user.avatar }}" width="64px" height="64px" class="border rounded-circle align-top">
                <div class="d-inline-block">
                    <div>
                        <code><a routerLink="/users/{{ message.user.id }}">#{{ message.user.id }}</a></code>
                    </div>
                    <div>
                        <strong>{{ message.user.name }}</strong>
                    </div>
                    <div [class.text-muted]="!message.user.banned" [class.text-danger]="message.user.banned" style="line-height: 1; cursor: pointer;" (click)="updateUserBanned(!message.user.banned)">
                        <small [class.font-weight-normal]="!message.user.banned" [class.font-weight-bold]="message.user.banned">banned</small>&nbsp;<i class="fas align-middle" [class.fa-toggle-off]="!message.user.banned" [class.fa-toggle-on]="message.user.banned"></i>
                    </div>
                </div>
            </div>
            <div class="float-end text-end">
                <div>
                    <code><a routerLink="/community/messages/{{ message.id }}">#{{ message.id }}</a></code>
                </div>
                <div>
                    <div class="form-check form-check-inline d-inline-flex align-items-center m-0 ps-1">
                        <label class="form-check-label" [class.text-danger]="message.deleted" [class.font-weight-bold]="message.deleted" for="messageDeletedControl_{{ message.id }}">deleted</label>
                        <select id="messageDeletedControl_{{ message.id }}" class="form-select form-select-sm" #messageDeletedControl (change)="messageDeletedControlChange(messageDeletedControl.value)">
                            <option value="false" [selected]="!message.deleted">No</option>
                            <option value="true" [selected]="message.deleted">Yes</option>
                        </select>
                    </div>
                    <div class="form-check form-check-inline d-inline-flex align-items-center m-0 ps-1">
                        <label class="form-check-label" [class.text-danger]="message.inappropriate != null && message.inappropriate" [class.font-weight-bold]="message.inappropriate != null && message.inappropriate" for="messageInappropriateControl_{{ message.id }}">inappropriate</label>
                        <select id="messageInappropriateControl_{{ message.id }}" class="form-select form-select-sm" #messageInappropriateControl (change)="messageInappropriateControlChange(messageInappropriateControl.value)">
                            <option value="undefined" [selected]="message.inappropriate == null">―</option>
                            <option value="false" [selected]="message.inappropriate != null && !message.inappropriate">No</option>
                            <option value="true" [selected]="message.inappropriate != null && message.inappropriate">Yes</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="mb-2">
            <div class="float-start">
                <small class="text-muted">{{ message.location ? message.location.description : 'Unknown location' }}</small>
            </div>
            <div class="float-end text-end">
                <small class="text-muted">{{ message.datetime | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</small>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="mb-2">
            <blockquote class="blockquote m-0">“ {{ message.text }} ”</blockquote>
        </div>
        <div class="mb-2" *ngIf="message.photo">
            <img class="img-fluid w-100 border rounded" style="cursor: pointer;" src="{{ message.photo.thumbnail }}" (click)="emitPhotoClickEvent()">
        </div>
        <div class="mb-2 card-group text-center" *ngIf="message.activity">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">{{ message.activity.steps }}</h5>
                    <p class="card-text">steps</p>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">{{ message.activity.distance }}</h5>
                    <p class="card-text">meters</p>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">{{ message.activity.duration }}</h5>
                    <p class="card-text">seconds</p>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">{{ message.activity.calories }}</h5>
                    <p class="card-text">calories</p>
                </div>
            </div>
        </div>
        <div class="mb-2 card-group text-center" *ngIf="message.challenge">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">challenge #{{ message.challenge.id }}</h5>
                </div>
            </div>
        </div>
        <div class="mb-2">
            <div class="row gx-1">
                <div class="col-auto">
                    <button class="btn btn-sm fnt-sm btn-info text-light" (click)="likeButtonClick()" [disabled]="message.likeInProgress">
                        <i class="far fa-heart" [class.far]="!message.isInLikes" [class.fas]="message.isInLikes"></i> Likes
                        <span class="badge bg-light text-dark">{{ message.numLikes }}</span>
                    </button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm fnt-sm btn-info text-light" (click)="emitCommentClickEvent()">
                        <i class="far fa-comments" [class.far]="!message.isInComments" [class.fas]="message.isInComments"></i> Comments
                        <span class="badge bg-light text-dark">{{ message.numComments }}</span>
                    </button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm fnt-sm btn-info text-light" style="pointer-events: none;">
                        <i class="fas fa-bullhorn"></i> Reports
                        <span class="badge bg-light text-dark">{{ message.numReports }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>